import FullInfoField from 'components/FullInfoField/FullInfoField';
import React, { useContext } from 'react';
import {
	IRestaurantFullInfoContext,
	RestaurantFullInfoContext,
} from '../../../../../../../../../restaurantFullInfoState/restaurantFullInfoContext';
import style from './SourceIdField.module.scss';

const SourceIdField: React.FC = () => {
	const { restaurantForFullInfo } = useContext<IRestaurantFullInfoContext>(RestaurantFullInfoContext);

	return (
		<FullInfoField
			label="sourceIdLabel"
			value={restaurantForFullInfo?.vivaWalletIsv?.sourceId}
			containerClassName={style.container}
		/>
	);
};

export default SourceIdField;
